import codiors from "../assets/codiors-main-img.png";

import img1 from "../assets/codiors/img-1.png";
import img2 from "../assets/codiors/img-2.png";
import img3 from "../assets/codiors/img-3.png";
import img4 from "../assets/codiors/img-4.png";
import img5 from "../assets/codiors/img-5.png";
import img6 from "../assets/codiors/img-6.png";
import img7 from "../assets/codiors/img-7.png";
import img8 from "../assets/codiors/img-8.png";
import img9 from "../assets/codiors/img-9.png";
import img10 from "../assets/codiors/img-10.png";
import img11 from "../assets/codiors/img-11.png";
import img12 from "../assets/codiors/img-12.png";

const Items = [
  {
    id: 1,
    mainImage: codiors,
    img: [
      img1,
      img2,
      img3,
      img4,
      img5,
      img6,
      img7,
      img8,
      img9,
      img10,
      img11,
      img12,
    ],
    features: [
      "User registration and login",
      "Authentication using JWT Tokens",
      "Searching and pagination",
      "CRUD operations",
      "Upload user ımages to the server",
      "Responsive Design",
      "404 Page and many more.",
    ],
    technologies: [
      "React",
      "React Vite",
      "React Hooks",
      "React Router Dom",
      "React Icons",
      "Material UI",
      "Axios",
      "CSS",
      "UUID",
      "NodeJS",
      "ExpressJS",
      "MySQL",
      "Stripe",
      "gemini",
      "Google Cloud",
      "Rapid API",
      "Judge0",
    ],
    title: "Codiors",
    description:
      "A  platform is designed to help you enhance your programming skills, tackle complex problems, and connect with a community of like-minded developers.",
    category: "personal",
    liveLink: "https://codiors.vercel.app/",
    // codeLink: "",
  },
];

export default Items;
